import { useState } from 'react'
import { useLang } from '../i18n'
import { OverviewPage } from './OverviewPage'
import { RegionalPage } from './RegionalPage'
import { LeaderboardPage } from './LeaderboardPage'
import { TrendAnalysisPage } from './TrendAnalysisPage'

type StatsTab = 'overview' | 'regional' | 'leaderboard' | 'trend'

const STATS_TABS: StatsTab[] = ['overview', 'regional', 'leaderboard', 'trend']

const TAB_KEY_MAP: Record<StatsTab, string> = {
  overview: 'statsHubTabOverview',
  regional: 'statsHubTabRegional',
  leaderboard: 'statsHubTabLeaderboard',
  trend: 'statsHubTabTrend',
}

export function StatsHubPage() {
  const { t } = useLang()
  const [activeTab, setActiveTab] = useState<StatsTab>('overview')

  return (
    <div data-testid="stats-hub-page">
      <div
        data-testid="stats-hub-tabs"
        style={{
          display: 'flex',
          gap: '4px',
          marginBottom: '24px',
          borderBottom: '2px solid var(--border, #e5e7eb)',
        }}
      >
        {STATS_TABS.map((tab) => (
          <button
            key={tab}
            data-testid={`stats-tab-${tab}`}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '8px 16px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === tab ? 600 : 400,
              color: activeTab === tab ? 'var(--accent, #2563eb)' : 'inherit',
              borderBottom: activeTab === tab ? '2px solid var(--accent, #2563eb)' : '2px solid transparent',
              marginBottom: '-2px',
            }}
          >
            {t(TAB_KEY_MAP[tab])}
          </button>
        ))}
      </div>
      <div data-testid="stats-hub-content">
        {activeTab === 'overview' && <OverviewPage />}
        {activeTab === 'regional' && <RegionalPage />}
        {activeTab === 'leaderboard' && <LeaderboardPage />}
        {activeTab === 'trend' && <TrendAnalysisPage />}
      </div>
    </div>
  )
}
